import { Box, Button, InputLabel, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import PhoneInput from './PhoneInput';

import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import { useOrderCourseCheckout } from '../../hooks/useOrderCourseCheckout';
import { useGet } from '../../hooks/useApi';
import { useParams } from 'react-router-dom';
const countryCodes = getCountries().map(country => {
    try {
      return {
        code: `+${getCountryCallingCode(country)}`,
        country: country,
      }
    } catch (error) {
      console.log(`Error with country: ${country}`, error);
      return null;
    }
  }).filter(Boolean).sort((a, b) => a.code.localeCompare(b.code));
export default function CourseForm({setOnClose,setOpenModal}) {
  const {id} = useParams();
    const [formData, setFormData] = useState({
      
      phoneNumber:'',
        userEmail: '',
        courseId: Number(id)
    
      });
      const isValid = formData.userEmail !=='' && formData.phoneNumber !==''
      const handleChange = (event) => {
        const { name, value } = event.target; // Extract name and value from the input element
        console.log(value)
        setFormData((prevData) => ({
          ...prevData,
          [name]: value, // Dynamically update the field based on its name
       
       
        }));
      };
    //   const [open, setOpen] = useState(false)
    const [countryCode, setCountryCode] = useState('+234');
    const [phoneNumber, setPhoneNumber] = useState('');
 
    
    const handleCountryCodeChange = (value) => {
      setCountryCode(value);
      setFormData(prev => ({
        ...prev,
        phoneNumber: `${value}${phoneNumber}` // Update combined phone in formData
      }));
    };
  const {submitOrder,isSubmitting} = useOrderCourseCheckout();
  const { data: validateCustomer} = useGet('/api/GiftItems/validate-Customer', {
    staleTime: 60000,
  });
  const customerEmail = validateCustomer?.data.userEmail
  console.log(customerEmail)
    const handlePhoneNumberChange = (value) => {
      const cleanNumber = value.startsWith('0') ? value.slice(1) : value;
      console.log(cleanNumber);
      setPhoneNumber(cleanNumber);
      setFormData(prev => ({
        ...prev,
        phoneNumber: `${countryCode}${cleanNumber}` // Update combined phone in formData
      }));
    };
    //   const handleSubmit = (event) => {
    //     event.preventDefault();
    
    //     console.log(formData);
       
    //     setOnClose(false)
        
    //   };
     const handleClick =  async (event) => {
        event.preventDefault();
        console.log(formData);
        try{
          await submitOrder(formData,customerEmail)
          setOnClose(false)
         setOpenModal(true)
        }catch(err) {
          console.log(err);
          
        }
  
     }
  return (
    <Box>
         {/* <Box sx={{backgroundColor:'rgba(252, 228, 177, 1)', my:3, p:2, borderRadius:'4px'}}>
    <Typography sx={{borderBottom:'1px solid rgba(83, 80, 92, 1)', p:2, textTransform:'capitalize', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
          <span>
              Amount to be Paid
          </span>
          <span>
              ₦10,000
          </span>
      </Typography>
      <Typography sx={{py:1, backgroundColor:'rgba(246, 167, 4, 1)', my:1, borderRadius:'4px', p:2,textTransform:'capitalize', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
      <span>
          Available Balance
      </span>
      <span>
          ₦63,234.03
      </span>
      </Typography>
  </Box> */}
  <form >
    <Box sx={{border:'1px solid rgba(238, 230, 254, 1)', p: 2, borderRadius:'10px', marginTop:4,fontFamily: theme=> theme.typography.smallText,}}>

   
    <InputLabel sx={{textTransform: 'capitalize', fontWeight: 600}}> Your whatsapp phone number</InputLabel>
         <PhoneInput
        countryCode={countryCode}
        phoneNumber={phoneNumber}
        onCountryCodeChange={handleCountryCodeChange}
        onPhoneNumberChange={handlePhoneNumberChange}
        valid={isValid}
        countryCodes={countryCodes}
      />


  <InputLabel sx={{textTransform: 'capitalize', fontWeight: 600}}>email address</InputLabel>
        
        <TextField
          hiddenLabel
     
       
          size="small"
          placeholder="@adewalemail.com" // Placeholder inside input
          variant="outlined"
          fullWidth
          name="userEmail"
          sx={{ backgroundColor:'rgba(255, 255, 255, 1)', my:2, color: 'rgba(182, 183, 185, 1)',borderRadius: '10px'}}
          value={formData.email}
          onChange={handleChange}
       
        />
       
        </Box>
       
       <Box sx={{background:'rgba(254, 246, 230, 1)', border:'2px solid rgba(254, 246, 230, 1)', p:2, mt: 3, mb: 6}}>
        <Typography>The course materials will be sent to the receipent email and WhatsApp entered below</Typography>
       </Box>
       
        <Button variant="contained"
                onClick={handleClick}
                disabled={!isValid}
                  sx={{width:'100%',display:'flex', alignItems:'center', gap:1, textTransform:'none','&.Mui-disabled': {
            backgroundColor: 'rgba(86, 4, 246, 0.2)', // Background color when button is disabled
            color: 'rgba(255, 255, 255, 1)', // Text color when button is disabled
          }, color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', py:1, px:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:600,
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}>Complete Checkout</Button>
      </form>
      {/* {open && <AppModal setShowModal={setOpen} showModal={open}/>} */}
  </Box>
  )
}
